(function () {
  function initFaq(root) {
    if (!root || root.dataset.scenarioFaqInit === 'true') return;
    root.dataset.scenarioFaqInit = 'true';

    const items = Array.from(root.querySelectorAll('[data-faq-item]'));
    if (!items.length) return;

    function activate(scenario) {
      if (!scenario) return;

      items.forEach((item) => {
        const key = item.dataset.faqScenario || '';
        const isVisible = !key || key === scenario;
        item.hidden = !isVisible;
        if (!isVisible) item.open = false;
      });
    }

    root.addEventListener('toggle', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLDetailsElement) || !target.open) return;
      items.forEach((item) => {
        if (item !== target) item.open = false;
      });
    });

    document.addEventListener('scenario:change', (event) => {
      const detail = event.detail || {};
      activate(detail.scenario);
    });

    document.addEventListener('scenario:moment-change', (event) => {
      const detail = event.detail || {};
      if (detail.scenario) activate(detail.scenario);
    });

    const activeTab = document.querySelector('[data-scenario-tab].is-active');
    if (activeTab) activate(activeTab.dataset.scenarioTab);
  }

  function initAll() {
    document.querySelectorAll('[data-scenario-faq]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root =
      event.target.querySelector('[data-scenario-faq]') ||
      event.target.closest('[data-scenario-faq]');
    if (root) initFaq(root);
  });
})();
